// extracted by mini-css-extract-plugin
module.exports = {"button":"DismissButton_button__xJuZ2"};